import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Grid, Box, Typography } from '@mui/material';
import CreateCampaign from '../createCampaign';
import {
    CustomReactSelect,
    CustomButton,
    CustomModal,
    ConfirmationModal,
} from '../../../shared';
import { PlusIcon, Trash } from '../../../../assets';
import { actions as companyActions } from '../../../../redux/reducers/companyReducer';
import { actions as campaignActions } from '../../../../redux/reducers/campaignReducer';
import { deleteCampaigns, getAllCampaigns } from '../../../../redux/thunks/campaignThunks';

const FilterBar = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { companyOptions, company: selectedCompany } = useSelector((state) => state.company);
    const { userDetails: { is_admin, is_staff = 0, company: userCompany } } = useSelector((state) => state.user);
    const { selectedRows } = useSelector((state) => state.campaign);
    const { setCompany } = companyActions;
    const { resetCampaignState } = campaignActions;
    const [showModal, setShowModal] = useState(false);
    const [showDeletCampaignModal, setShowDeletCampaignModal] = useState(false);

    const handleShowModal = () => {
        setShowModal(!showModal);
    };

    const handleDeleteCampaignModal = () => {
        setShowDeletCampaignModal(!showDeletCampaignModal);
    };

    const handleCancel = () => {
        dispatch(resetCampaignState());
        handleShowModal();
    };

    const handleCreateCampaign = () => {
        handleShowModal();
    };

    const handleCompanyChange = (option) => {
        dispatch(setCompany(option));
    };

    const handleDeleteCampaign = () => {
        if(selectedRows && selectedRows.length > 0){
            dispatch(deleteCampaigns({
                companyId: selectedCompany.id, 
                campaignIds: {
                    ids: selectedRows
                },
            })).then(()=> {
                handleDeleteCampaignModal();
                dispatch(getAllCampaigns({ companyId: selectedCompany.id }));
            }).catch((error)=> {
                console.error("Error in Deleting Campaigns", error)
            });
            
            
        }
    };

    return (
        <>
            <Grid container className="flex-row-space-between mb-24px mt-10px">
                <Grid item xs={6}>
                    <Box className="flex-row gap-12">
                        <Box className="w-50">
                            <CustomReactSelect
                                options={companyOptions}
                                handleFilter={handleCompanyChange}
                                selectedOption={{
                                    label: selectedCompany.name,
                                    value: selectedCompany.id,
                                }}
                                customStyle={{ borderRadius: '50px' }}
                                placeholder="Select Company"
                            />
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={6}>
                    <Box className="flex-row-end gap-12">
                        <CustomButton
                            title="Create New"
                            titleColor="#FFFFFF"
                            buttonColor="#AD509E"
                            icon={<PlusIcon color="#FFFFFF" />}
                            handleClick={handleCreateCampaign}
                        />
                        <CustomButton
                            title="Delete Campaign"
                            icon={<Trash />}
                            handleClick={handleDeleteCampaignModal}
                        />
                    </Box>
                </Grid>
            </Grid>
            <CustomModal
                modalOpen={showModal}
                component={<CreateCampaign handleClose={handleCancel} />}
            />
            <ConfirmationModal
                open={showDeletCampaignModal}
                onClose={handleDeleteCampaignModal}
                content={
                    <Box>
                        <Typography className="mb-20px mt-20px" variant="body1">
                            Are you sure you want to delete this campaign?
                        </Typography>
                        <Box className="mb-20px mt-20px">
                            <Typography variant="body2" color="error">
                                Warning: This action cannot be undone!
                            </Typography>
                        </Box>
                    </Box>
                }
                title={
                    <Typography className="queries-table-title">
                        Delete Campaign
                    </Typography>
                }
                primaryButtonText={'Confirm'}
                onConfirm={handleDeleteCampaign}
            />
        </>
    );
};

export default FilterBar;
